// extracted by mini-css-extract-plugin
export default {"block":"Menu_block__g5kMC","link":"Menu_link__TGa4e","active":"Menu_active__uOaCD","text":"Menu_text__xKoo4"};